/**
 * lucide-react v0.279.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const ChevronUp = createLucideIcon("ChevronUp", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);

export { ChevronUp as default };
//# sourceMappingURL=chevron-up.js.map
